import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

import * as Styles from '../Icon.module.scss';

export const RequiredIcon = ({ size = 'medium' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles['dsgGreen'], Styles.fill);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            className={fillStyle}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M20 0c11.046 0 20 8.954 20 20s-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0zm.5 9.5a1 1 0 0 0-1 1v7.585l-5.364-5.363-.094-.083a1 1 0 0 0-1.32 1.497l5.363 5.364H10.5l-.117.007A1 1 0 0 0 10.5 21.5h7.585l-5.363 5.364-.083.094a1 1 0 0 0 1.497 1.32l5.364-5.364V30.5l.007.117A1 1 0 0 0 21.5 30.5v-7.585l5.364 5.363.094.083a1 1 0 0 0 1.32-1.497L22.915 21.5H30.5l.117-.007A1 1 0 0 0 30.5 19.5h-7.585l5.363-5.364.083-.094a1 1 0 0 0-1.497-1.32L21.5 18.084V10.5l-.007-.117A1 1 0 0 0 20.5 9.5z"
                fillRule="evenodd"
            />
        </svg>
    );
};
